import { render } from "./CallbackPage.vue?vue&type=template&id=40af1420&scoped=true"
import script from "./CallbackPage.vue?vue&type=script&lang=js"
export * from "./CallbackPage.vue?vue&type=script&lang=js"

import "./CallbackPage.vue?vue&type=style&index=0&id=40af1420&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40af1420"]])

export default __exports__